// extracted by mini-css-extract-plugin
module.exports = {"table-wapper":"style_table-wapper__C-Blz"};